import React from 'react';

/**
 * Fixome Logo Component
 * Right-sized AVIF/WebP logo; width and height match the 600×249 artwork.
 */
const LOGO_WIDTH = 600;
const LOGO_HEIGHT = 249;
const LOGO_WIDTHS = [160, 320, 480];

const logoSrcSet = (ext) =>
  LOGO_WIDTHS.map((w) => `/optimized/logo-${w}.${ext} ${w}w`).join(', ');

const FixomeLogo = ({ size = 'medium', showTagline = false, className = '' }) => {
  const sizes = {
    small: { logoHeight: 50, taglineSize: 6 },
    medium: { logoHeight: 60, taglineSize: 8 },
    large: { logoHeight: 70, taglineSize: 10 },
    xl: { logoHeight: 80, taglineSize: 12 },
  };

  const { logoHeight, taglineSize } = sizes[size] || sizes.medium;

  return (
    <div className={`inline-flex flex-col items-start ${className}`}>
      <picture>
        <source type="image/avif" srcSet={logoSrcSet('avif')} sizes="(max-width: 390px) 103px, 145px" />
        <source type="image/webp" srcSet={logoSrcSet('webp')} sizes="(max-width: 390px) 103px, 145px" />
        <img
          src="/optimized/logo-320.webp"
          alt="Fixome"
          width={LOGO_WIDTH}
          height={LOGO_HEIGHT}
          className="object-contain"
          style={{
            height: `var(--fx-logo-h, ${logoHeight}px)`,
            width: 'auto',
            aspectRatio: `${LOGO_WIDTH} / ${LOGO_HEIGHT}`,
          }}
        />
      </picture>

      {/* Tagline */}
      {showTagline && (
        <span
          style={{
            fontFamily: 'Inter, sans-serif',
            fontSize: `${taglineSize}px`,
            fontWeight: 400,
            color: '#6D4C41',
            marginTop: '1px',
            letterSpacing: '0.02em',
            lineHeight: 1,
          }}
        >
          Home Maintenance Solution
        </span>
      )}
    </div>
  );
};

export default FixomeLogo;


